import { render, staticRenderFns } from "./Info2.vue?vue&type=template&id=100cef3c&scoped=true&"
import script from "./Info2.vue?vue&type=script&lang=js&"
export * from "./Info2.vue?vue&type=script&lang=js&"
import style0 from "./Info2.vue?vue&type=style&index=0&id=100cef3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100cef3c",
  null
  
)

export default component.exports